import React from "react";
import { Segment, Header } from "semantic-ui-react";

function Pago(props) {
  return (
    <Segment textAlign="center" color="pink">
      <Header as="h3">
        Datos bancarios para efectuar el pago: ES10 0081 0626 9100 0218 1524
      </Header>
      <Header as="h4">(Titular: Aristas Educación, S.L.)</Header>
      <div>
        (Recuerde indicar el <u>nombre del alumno</u> como concepto de pago)
      </div>
      <div>
        La inscripción no estará completa hasta que se envíe el justificante de
        pago a la dirección escuelas@grupoaristas.com, indicando el nº de
        resguardo
      </div>
    </Segment>
  );
}

export default Pago;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/inscripcionConfirmada/formularioInscripcion/Pago.jsx